import { useState, useEffect } from "react";
import { auth } from "../firebase";

function Practice() {
  const user = auth.currentUser;
  const userKey = user?.email || "guest";

  const [solved, setSolved] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    const data = JSON.parse(
      localStorage.getItem(`solvedQuestions_${userKey}`)
    ) || [];
    setSolved(data);
  }, [userKey]);

  const questions = [
    ...Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `Easy Problem ${i + 1}`,
      difficulty: "Easy",
      description: `Solve easy problem ${i + 1}`,
    })),

    ...Array.from({ length: 40 }, (_, i) => ({
      id: i + 41,
      title: `Medium Problem ${i + 41}`,
      difficulty: "Medium",
      description: `Solve medium problem ${i + 41}`,
    })),

    ...Array.from({ length: 20 }, (_, i) => ({
      id: i + 81,
      title: `Hard Problem ${i + 81}`,
      difficulty: "Hard",
      description: `Solve hard problem ${i + 81}`,
    })),
  ];

  const toggleSolved = (id) => {
    let updated;

    if (solved.includes(id)) {
      updated = solved.filter((q) => q !== id);
    } else {
      updated = [...solved, id];
    }

    setSolved(updated);
    localStorage.setItem(
      `solvedQuestions_${userKey}`,
      JSON.stringify(updated)
    );
  };

  const filteredQuestions =
    filter === "All"
      ? questions
      : questions.filter((q) => q.difficulty === filter);

  const total = questions.length;
  const solvedCount = solved.length;
  const remaining = total - solvedCount;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Practice Questions 💻</h2>

      {/* STATS */}
      <div style={styles.stats}>
        <span style={{ color: "#4CAF50" }}>
          Solved: {solvedCount} ✅
        </span>
        <span style={{ color: "#f44336" }}>
          Remaining: {remaining} ❌
        </span>
      </div>

      {/* PROGRESS BAR */}
      <div style={styles.progressBox}>
        <div style={styles.progressBg}>
          <div
            style={{
              ...styles.progressFill,
              width: `${(solvedCount / total) * 100}%`,
            }}
          ></div>
        </div>
      </div>

      {/* FILTER */}
      <div style={styles.filterBox}>
        {["All", "Easy", "Medium", "Hard"].map((type) => (
          <button
            key={type}
            onClick={() => setFilter(type)}
            style={styles.filterBtn}
          >
            {type}
          </button>
        ))}
      </div>

      <h3 style={{ marginTop: "10px" }}>
        Total: {filteredQuestions.length}
      </h3>

      {/* RESET */}
      <button
        onClick={() => {
          setSolved([]);
          localStorage.removeItem(`solvedQuestions_${userKey}`);
        }}
        style={styles.reset}
      >
        Reset Progress 🔄
      </button>

      {/* QUESTIONS */}
      {filteredQuestions.map((q) => (
        <div key={q.id} style={styles.card}>
          <h3>{q.title}</h3>
          <p>Difficulty: {q.difficulty}</p>
          <p>{q.description}</p>

          <button
            onClick={() => toggleSolved(q.id)}
            style={{
              ...styles.solveBtn,
              background: solved.includes(q.id) ? "#ff9800" : "#4CAF50",
            }}
          >
            {solved.includes(q.id)
              ? "Mark as Unsolved ❌"
              : "Mark as Solved ✅"}
          </button>
        </div>
      ))}
    </div>
  );
}

// 🔥 STYLES
const styles = {
  container: {
    padding: "20px",
    background: "#1e1e2f",
    minHeight: "100vh",
    color: "white",
  },

  title: {
    marginBottom: "10px",
  },

  stats: {
    display: "flex",
    gap: "20px",
    marginBottom: "10px",
    fontWeight: "bold",
  },

  progressBox: {
    marginBottom: "15px",
  },

  progressBg: {
    height: "10px",
    background: "#444",
    borderRadius: "5px",
  },

  progressFill: {
    height: "100%",
    background: "#4CAF50",
    borderRadius: "5px",
  },

  filterBox: {
    marginBottom: "15px",
  },

  filterBtn: {
    margin: "5px",
    padding: "8px 12px",
    background: "#333",
    color: "white",
    border: "1px solid #555",
    borderRadius: "5px",
    cursor: "pointer",
  },

  reset: {
    marginBottom: "15px",
    padding: "10px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },

  card: {
    background: "rgba(255,255,255,0.1)",
    borderRadius: "10px",
    margin: "10px",
    padding: "15px",
    border: "1px solid rgba(255,255,255,0.2)",
  },

  solveBtn: {
    padding: "8px",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default Practice;